export const getIsAsyncTaskProcessing = (workplan) =>
    workplan.isRollingOut
    || workplan.isPausing
    || workplan.isStopping
    || workplan.isImportingExcel
    || workplan.isReloadingCoverage;
    